/**
 * Provides an interface for modifying the list of rules associated with a `Field`.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Field` containing models associated with this view.
 * @module app/views/layer/DataFieldRuleValueControlEditor
 */
import Backbone from "backbone";
import _ from "underscore";
import ButtonView from "core/views/ButtonView";

export default Backbone.View.extend({
  template: _.template(
    '<div class="rule-field divVisibleField"><div class="col-sm-11 form-group"><select class="form-control" id="ruleField"></select></div><div class="field-toggles btn-group btn-group-xs field-top"></div></div>'
  ),

  initialize: function (options) {
    this.options = options;
    this.model = this.options.model;
    this.value = this.options.value;
    this.rules = this.options.rules;
    this.field = this.options.field;
    this.fields = this.options.fields;
  },

  render: function () {
    var self = this;
    this.$el.html(this.template(_.defaults({}, this.options, {})));
    var $ruleField = this.$("#ruleField");

    var deleteVisibleField = new ButtonView({
      click: function () {
        var $div = self.$(".divVisibleField");
        if ($div.length > 0) {
          $div[0].remove();
        }
        self.field.removeValueRule(self.model, self.value.value);
      },
      text: "",
      icon: "trash",
      className: "btn-danger",
      tooltip: "Delete Visible Field",
      attributes: {
        tabindex: "-1",
      },
    });

    deleteVisibleField.render();
    this.$(".field-toggles").append(deleteVisibleField.$el);

    $ruleField.html("");

    var visibleFields = this.fields.filter(function (field) {
      return (
        field.get("visible") == false && field.get("id") != self.field.get("id")
      );
    });
    if (
      visibleFields.length > 0 &&
      (this.model == undefined || this.model == "")
    ) {
      self.model = visibleFields[0].get("id");
      self.field.addValueRule(self.model, self.value.value);
    }
    visibleFields.forEach(function (field) {
      if (field.get("id") == self.model) {
        $ruleField.append(
          "<option value='" +
            field.get("id") +
            "' selected>" +
            field.get("label") +
            "</option>"
        );
      } else {
        $ruleField.append(
          "<option value='" +
            field.get("id") +
            "'>" +
            field.get("label") +
            "</option>"
        );
      }
    });

    $ruleField.change(function () {
      if (self.model != $ruleField[0].value) {
        if (self.model != undefined) {
          self.field.removeValueRule(self.model, self.value.value);
        }
        self.model = $ruleField[0].value;
        self.field.addValueRule(self.model, self.value.value);
      }
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layer/DataFieldRuleValueControlEditor.js
// module id = 890
// module chunks = 1